module.exports = __webpack_public_path__ + "static/media/times-circle-regular.8a26aaa5.jpg";